export const selectOptionsExceptionRiskBucket = [
  "Collateral Quality",
  "Credit Structure",
  "Market Risk",
  "Borrower Profile",
  "Legal & Structural Risk",
];
